import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { trackFeedbackAction } from '../../utils/analytics';
import { usePrivacyPolicy } from '../../hooks/usePrivacyPolicy';
import { updatePrivacyPolicyStatus } from '../../services/privacyPolicyService';

export default function FeedbackButton({ user }) {
  const [showForm, setShowForm] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { privacyPolicyAccepted } = usePrivacyPolicy();

  const buttonDisabled = (!privacyPolicyAccepted && !isAccepted) || !feedback.trim() || isLoading;

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!privacyPolicyAccepted && !isAccepted) {
      return;
    }

    setIsLoading(true);

    const messageInfo = {
      name: user?.['custom:name'] || 'Unknown',
      email: user?.email || 'Unknown',
      organization: user?.['custom:company'] || 'Unknown',
      message: feedback,
      subject: 'feedback',
    };

    try {
      const userId = user?.sub || user?.username;
      await updatePrivacyPolicyStatus(userId, true);

      const response = await fetch('https://p3xqewey7e.execute-api.eu-central-1.amazonaws.com/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(messageInfo),
      });

      if (response.ok) {
        Swal.fire({
          title: 'Thank you for your feedback!',
          confirmButtonText: `<i class="fa fa-thumbs-up"></i> Great!`,
        });
      } else {
        console.error('Error en la petición:', response.statusText);
        Swal.fire('Oops! Something went wrong.');
      }
    } catch (e) {
      console.error(e);
      Swal.fire('Error sending feedback. Try again later.');
    } finally {
      setIsLoading(false);
    }

    setFeedback('');
    setShowForm(false);
  };

  const handleCloseFeedback = () => {
    trackFeedbackAction('feedback_close');
    setShowForm(false);
  };

  return (
    <div>
      <button
        className={isMobile ? 'btn-feedback-mobile' : 'btn-feedback-gradient-pink'}
        onClick={() => setShowForm(!showForm)}
      >
        {isMobile ? (
          <>
            <img src="../../../static/images/icons/feedback.png" alt="icono feedback" />
          </>
        ) : (
          <>Feedback</>
        )}
      </button>
      <form>
        {showForm && (
          <div className={isMobile ? 'mobile-form-feedback' : 'form-feedback '}>
            <textarea
              className="filter-textarea"
              style={{
                width: '100%',
                height: isMobile ? '150px' : '200px',
                fontSize: isMobile ? '10px' : '16px',
                resize: 'vertical',
                minHeight: '100px',
              }}
              value={feedback}
              onChange={e => setFeedback(e.target.value)}
              placeholder="Help us improve DISGENET by sharing your feedback with us"
            />
            <div
              style={{
                display: 'flex',
                gap: '8px',
                justifyContent: 'center',
                flexWrap: 'wrap',
                marginTop: '12px',
              }}
            >
              {!privacyPolicyAccepted && (
                <>
                  <div className="flex items-center mb-4">
                    <input
                      type="checkbox"
                      id="privacy-accept"
                      checked={isAccepted}
                      onChange={e => setIsAccepted(e.target.checked)}
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label htmlFor="privacy-accept" className="ml-2 text-sm text-gray-700 mb-0">
                      I&apos;ve read and accept the{' '}
                      <a
                        href="/Privacy-policy"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        privacy policies
                      </a>
                      .
                    </label>
                  </div>
                </>
              )}
              <button
                disabled={buttonDisabled}
                onClick={handleSubmit}
                className={`${
                  buttonDisabled
                    ? 'bg-gray-400 text-white font-bold py-2 px-6 rounded-full cursor-not-allowed'
                    : 'btn-gradient-pink'
                }`}
                style={{ margin: '4px', fontSize: isMobile ? '0.7rem' : '' }}
              >
                {isLoading ? 'Loading...' : 'Send'}
              </button>

              <button className="btn-gradient-blue" onClick={handleCloseFeedback} style={{ margin: '4px' }}>
                Close
              </button>
            </div>
          </div>
        )}
      </form>
    </div>
  );
}
